<template>
    <views class="faq">
        <nav-bar
            title="我的意见"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views class="faq-search">
            <search-bar
                :path="path"
                :querys="querys"></search-bar>
        </views>
        <views class="faq-list">
            <van-list
                v-model="loadingData"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
                <div>
                    <div
                        class="bottom_line"
                        v-for="(item, index) in list"
                        :key="index">
                        <feed-item
                            :item="item">
                        </feed-item>
                    </div>
                </div>
                <div slot="finished" >
                    <div v-if="list.length==0 && keyword==''" class="no_data">
                        <div class="img-box">
                            <img :src="require('@/assets/images/no_data.png')" alt="">
                            <div>您未提交过意见反馈</div>
                        </div>
                        <router-link class="to-feed" to="/feedback" tag="div">提交反馈</router-link>
                    </div>
                    <div v-else>没有更多了</div>
                </div>
            </van-list>
        </views>
        <router-link class="edit-icon" to="/feedback" tag="div"></router-link>
    </views>
</template>
<script>
import NavBar from '@/components/navBar'
import SearchBar from '@/components/searchBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
import Item from './item'
export default {
    name: 'Faq',
    components: {
        NavBar,
        SearchBar,
        feedItem: Item
    },
    mixins: [tools],
    data() {
        return {
            pageNum: 1,
            loadingData: false,
            finished: false,
            keyword: '',
            list: []
        }
    },
    computed: {
        path() {
            return 'to=feedbacklist'
        },
        querys() {
            return this.$route.query || {}
        }
    },
    watch: {
        'querys.keyword': {
            handler(val) {
                this.keyword = val || ''
                this.reload()
            },
            immediate: true
        }
    },
    methods: {
        onClickLeft() {
            this.push('/person')
        },
        reload() {
            this.list = []
            this.finished = false
            this.loadingData = true
            this.onLoad()
        },
        onLoad() {
            const params = {
                page: this.pageNum,
                page_size: 10
            }
            if (this.keyword) params.topic = this.keyword
            api.getFeedbacklist(params).then(res => {
                if (res.data.list && res.data.list.length > 0) {
                    res.data.list.forEach((item) => {
                        this.list.push({ ...item })
                    })
                    this.loadingData = false
                    this.pageNum++
                } else {
                    this.finished = true
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
